export const MEASURE_TYPES = {
  GALLON: 'GALLON',
  TON: 'TON',
  YARD: 'YARD',
  POUND: 'POUND',
  ITEM: 'ITEM',
}
